<template>
  <div :class="{'m-0': noMargin}">
    <label
      :for="id"
      :class="{noLabelDisplayed: noLabelDisplayed}"
      class="col-form-label"
    >{{ label }}</label>
    <div :class="{noPadding: noPadding}">
      <div class="form-control-container">
        <input
          placeholder
          v-validate="validate"
          ref="input"
          :type="type"
          :name="id"
          :id="id"
          :data-vv-as="label.toLowerCase()"
          :value="stringValue"
          :disabled="disabled"
          class="form-control"
          data-vv-validate-on="input|blur|revalidate"
          @input="$event => updateValue($event)"
          @change="onChange($event.target.value)"
          @focus="$emit('focus')"
          @blur="$emit('blur')"
        >
      </div>
    </div>
    <!-- <div
      v-if="validationActive && errors.length > 0"
      class="form-control-validation is-invalid col-auto">
      <i
        v-b-tooltip.topleft.click.hover
        :title="errors.first(`${form}.${id}`)"
        class="material-icons d-flex align-items-center h-100">error_outline</i>
      <div
        class="tooltip bs-tooltip-top show d-none"
        role="tooltip"
        tabindex="-1"
        x-placement="top">
        <div class="arrow"/>
        <div class="tooltip-inner">{{ errors.first(`${form}.${id}`) }}</div>
      </div>
    </div>
    <div
      v-if="value && validationActive"
      class="form-control-validation is-valid">
      <i class="material-icons d-flex align-items-center h-100">check</i>
    </div>
    <div
      v-if="isRequired"
      class="form-control-validation">
      <span class="d-flex align-items-center h-100">*</span>
    </div>-->
  </div>
</template>
<script>
import { generateId } from "@/helpers/components";
import bTooltip from "bootstrap-vue/es/directives/tooltip/tooltip";

export default {
  inject: ["$validator"],
  directives: {
    bTooltip
  },
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      default: ""
    },
    validate: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    localizable: {
      type: Boolean,
      default: false
    },
    number: {
      type: Boolean,
      default: false
    },
    noMargin: {
      type: Boolean,
      default: false
    },
    noLabelDisplayed: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: "",
      id: generateId()
    };
  },
  computed: {
    isRequired() {
      return this.validate && this.validate.indexOf("required") !== -1;
    },
    validationActive() {
      return this.validate !== "";
    },
    stringValue() {
      if (this.value !== null) {
        return `${this.value}`;
      }
      return "";
    },
    validationPending() {
      if (
        this.fields &&
        this.fields[`$${this.form}`] &&
        this.fields[`$${this.form}`][this.id]
      ) {
        return this.fields[`$${this.form}`][this.id].pending;
      }
      return false;
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.$refs.input.dispatchEvent(
            new Event("revalidate", {
              bubbles: true,
              cancelable: true
            })
          );
        });
      }
    }
  },
  methods: {
    updateValue(event) {
      if (event && event.target) {
        let { value } = event.target;
        if (this.number || this.type === "number") {
          let numberValue = 0;

          if (value.indexOf(".") >= 0) {
            numberValue = parseFloat(value);
          } else if (value.indexOf(",") >= 0) {
            value = value.replace(",", ".");
            numberValue = parseFloat(value);
          } else {
            numberValue = parseInt(value, 10);
          }

          if (Number.isNaN(numberValue)) {
            this.$emit("input", value);
          }

          this.$emit("input", numberValue);
        } else {
          this.$emit("input", value);
        }
      }
    },
    onChange(value) {
      this.$emit("change", value);
    }
  }
};
</script>

<style scoped>
.noLabelDisplayed {
  display: none;
}
.noPadding {
  padding: 0px;
}
</style>
